module.exports = __webpack_public_path__ + "app/community/community-portal-3VTiju49.html";